import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';
import './index.css';

// Hydration / runtime error logging (browser only).
// Surfaces minified React errors (#418/#423/#425 = hydration mismatches)
// with stack traces so we can diagnose post-refresh interaction issues.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    const msg = e?.message ?? '';
    if (/Minified React error #(418|423|425|421|422)/.test(msg)) {
      // eslint-disable-next-line no-console
      console.error('[hydration]', e.error ?? msg);
    } else {
      // eslint-disable-next-line no-console
      console.error('[window.error]', e.error ?? msg);
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    // eslint-disable-next-line no-console
    console.error('[unhandledrejection]', e.reason);
  });
}

export const createRoot = ViteReactSSG({ routes });
